"use client";

import { usePathname, useRouter } from "@/i18n/navigation";
import { Locale } from "@/shared/types/locale";
import BottomSheet from "@/shared/ui/bottom-sheet";
import {
  Button,
  HStack,
  RadioCard,
  RadioGroup,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useLocale, useTranslations } from "next-intl";
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegCircleCheck } from "react-icons/fa6";
import { LuChevronRight, LuGlobe } from "react-icons/lu";
import { languageOptions } from "../model/constants";

const LanguageSwitcher = () => {
  const t = useTranslations("profile");
  const locale = useLocale() as Locale;
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<string | null>(locale);
  const pathname = usePathname();
  const router = useRouter();

  const selectLanguage = (selected: string | null) => {
    if (!selected) return;

    const newLocale = selected as Locale;
    setValue(newLocale);

    setIsOpen(false);

    setTimeout(() => {
      router.push(pathname, { locale: newLocale });
    }, 100);
  };

  return (
    <>
      <Button
        w="full"
        size="xl"
        variant="ghost"
        display="flex"
        justifyContent="space-between"
        onClick={() => setIsOpen(true)}
        borderBottom="1px solid"
        borderBottomColor="gray.100"
      >
        <HStack gap="4">
          <LuGlobe />
          <Text fontSize="md" color="gray.600">
            {t("language")}
          </Text>
        </HStack>
        <LuChevronRight size={32} />
      </Button>

      <BottomSheet isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <Text color={"text"} px={4} fontSize={24} fontWeight={700} mb="5">
          {t("select_language")}
        </Text>

        <RadioGroup.Root
          value={value}
          onValueChange={(e) => selectLanguage(e.value)}
        >
          <VStack alignItems="stretch">
            {languageOptions.map((item) => (
              <RadioGroup.Item
                key={item.value}
                w="full"
                value={item.value}
                p="4"
                justifyContent="space-between"
                borderBottom="1px solid"
                borderColor="gray.200"
              >
                <HStack>
                  <RadioCard.ItemHiddenInput />
                  {item.icon}
                  <RadioGroup.ItemText fontSize="">
                    {item.label}
                  </RadioGroup.ItemText>
                </HStack>

                {value === item.value ? (
                  <FaCheckCircle size="24" color="var(--primary-default)" />
                ) : (
                  <FaRegCircleCheck size="24" color="var(--bg-default)" />
                )}
              </RadioGroup.Item>
            ))}
          </VStack>
        </RadioGroup.Root>
      </BottomSheet>
    </>
  );
};

export default LanguageSwitcher;
